const TYPE = 'dataLayer';
let initFlag = false;

function gtmInclude(url, type = TYPE) {
    if (!url || initFlag) {
        return;
    }
    window[type] = window[type] || [];
    window[type].push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
    });
    const urlOption = type === TYPE ? '' : `&l=${type}`;
    const head = document.querySelector('head');
    const scriptTag = document.createElement('script');
    scriptTag.src = `${url}${urlOption}`;
    initFlag = true;
    head.appendChild(scriptTag);
}

export default gtmInclude;



// WEBPACK FOOTER //
// ./static-source/js/lib/utils/gtm_include.js